import superagent from 'superagent';

export default class Benefits {
  static get() {
    return superagent.get('https://portalcliente-dev.api.aureolab.cl/api/benefits');
  }
}
